import { autorun } from 'mobx';
import { useState, useEffect } from 'react';
import ManageTagModalStore from 'store/modules/proposal/ui/manageTagModalStore';
import RFQProposalPageStore from 'store/pages/rfq/rfq-response/proposal-rfq/pageStore';
import { useRFQCartItemDelegate } from 'store/pages/rfq/rfq-response/proposal-rfq/rfqCartItemContext';
import { useRootStore } from 'store/rootStore';

export default function useManageTagModalStore(): ManageTagModalStore<RFQProposalPageStore> {
  const { rfqProposalPageStore } = useRootStore();
  const cartItemDelegate = useRFQCartItemDelegate();

  const [store, setStore] = useState(
    () => new ManageTagModalStore({ pageStore: rfqProposalPageStore, cartItemDelegate }),
  );

  useEffect(() => {
    const disposer = autorun(() => {
      setStore(new ManageTagModalStore({ pageStore: rfqProposalPageStore, cartItemDelegate }));
    });
    return (): void => disposer();
  }, [cartItemDelegate]);

  return store;
}
